import { render } from "./Popup.vue?vue&type=template&id=3ebc0700&ts=true"
import script from "./Popup.ts?vue&type=script&lang=ts&external"
export * from "./Popup.ts?vue&type=script&lang=ts&external"

import "./Popup.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__